import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.map";
import _defineProperty from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es6.array.filter";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import { Body as BaseBody } from './base';
import { TableContext } from './Table';
import { isRowExpanded } from './utils';

var flagVisibility = function flagVisibility(rows) {
  var visibleRows = rows.filter(function (oneRow) {
    return !oneRow.parent || oneRow.isExpanded;
  });

  if (visibleRows.length > 0) {
    visibleRows[0].isFirstVisible = true;
    visibleRows[visibleRows.length - 1].isLastVisible = true;
  }
};

var ContextBody = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextBody, _React$Component);

  var _super = _createSuper(ContextBody);

  function ContextBody() {
    var _this;

    _classCallCheck(this, ContextBody);

    _this = _super.apply(this, arguments);

    _this.onRow = function (row, rowProps) {
      var _this$props = _this.props,
          onRowClick = _this$props.onRowClick,
          onRow = _this$props.onRow;
      var extendedRowProps = Object.assign(Object.assign({}, rowProps), onRow ? onRow(row, rowProps) : {});
      return {
        row: row,
        rowProps: extendedRowProps,
        onMouseDown: function onMouseDown(event) {
          var computedData = {
            isInput: event.target.tagName !== 'INPUT',
            isButton: event.target.tagName !== 'BUTTON'
          };
          onRowClick(event, row, rowProps, computedData);
        }
      };
    };

    _this.mapCells = function (headerData, row, rowKey) {
      // column indexes start after generated optional columns
      var additionalColsIndexShift = headerData[0].extraParams.firstUserColumnIndex;
      return Object.assign({}, row && (row.cells || row).reduce(function (acc, cell, cellIndex) {
        var isCellObject = cell === Object(cell);
        var isCellFunction = cell && typeof cell.title === 'function';

        var mappedCell = _defineProperty({}, headerData[cellIndex + additionalColsIndexShift].property, {
          title: isCellObject ? isCellFunction ? cell.title(cell.props.value, rowKey, cellIndex, cell.props) : cell.title : cell,
          props: Object.assign({
            isVisible: true
          }, isCellObject ? cell.props : null)
        }); // increment the shift index when a cell spans multiple columns


        if (isCellObject && cell.props && cell.props.colSpan) {
          additionalColsIndexShift += cell.props.colSpan - 1;
        }

        return Object.assign(Object.assign({}, acc), mappedCell);
      }, {
        id: row.id !== undefined ? row.id : rowKey
      }));
    };

    return _this;
  }

  _createClass(ContextBody, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          headerData = _a.headerData,
          rows = _a.rows,
          rowKey = _a.rowKey,
          children = _a.children,
          onRowClick = _a.onRowClick,
          props = __rest(_a, ["className", "headerData", "rows", "rowKey", "children", "onRowClick"]);

      var mappedRows;

      if (headerData.length > 0) {
        mappedRows = rows.map(function (oneRow, oneRowKey) {
          return Object.assign(Object.assign(Object.assign({}, oneRow), _this2.mapCells(headerData, oneRow, oneRowKey)), {
            isExpanded: isRowExpanded(oneRow, rows),
            isHeightAuto: oneRow.heightAuto || false,
            isFirst: oneRowKey === 0,
            isLast: oneRowKey === rows.length - 1,
            isFirstVisible: false,
            isLastVisible: false
          });
        });
        flagVisibility(mappedRows);
      }

      return React.createElement(React.Fragment, null, mappedRows && React.createElement(BaseBody, Object.assign({}, props, {
        mappedRows: mappedRows,
        rows: mappedRows,
        onRow: this.onRow,
        rowKey: rowKey,
        className: className
      })));
    }
  }]);

  return ContextBody;
}(React.Component);

export var TableBody = function TableBody(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$rowKey = _a.rowKey,
      rowKey = _a$rowKey === void 0 ? 'id' : _a$rowKey,
      _a$onRow = _a.onRow,
      onRow = _a$onRow === void 0 ? function () {
    return Object;
  } : _a$onRow,
      _a$onRowClick = _a.onRowClick,
      onRowClick = _a$onRowClick === void 0 ? function (event, row, rowProps, computedData) {
    return (
      /* eslint-enable @typescript-eslint/no-unused-vars */
      undefined
    );
  } : _a$onRowClick,
      props = __rest(_a, ["className", "children", "rowKey", "onRow", "onRowClick"]);

  return React.createElement(TableContext.Consumer, null, function (_a) {
    var _a$headerData = _a.headerData,
        headerData = _a$headerData === void 0 ? [] : _a$headerData,
        _a$rows = _a.rows,
        rows = _a$rows === void 0 ? [] : _a$rows,
        rest = __rest(_a, ["headerData", "rows"]);

    return React.createElement(ContextBody, Object.assign({
      headerData: headerData,
      rows: rows,
      onRow: onRow,
      className: className,
      rowKey: rowKey,
      onRowClick: onRowClick
    }, props, rest), children);
  });
};